"use client";

import React from "react";
import { LogoProps } from "../types";
import OmtoLogo from "../../../../../public/images/New-landing/omto-logo-complete.svg";

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <OmtoLogo
        alt="OMTO Logo"
        className="w-24 h-7"
      />
    </div>
  );
};

export default Logo;
